var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMarkTriangle17(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.248 2.498a.997.997 0 011.115.462h0l5.882 10.034a.997.997 0 01-.357 1.369 1 1 0 01-.506.137h0H2.618a.997.997 0 01-1-1 1 1 0 01.137-.506h0L7.637 2.96a.997.997 0 01.61-.462z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    fillRule: "nonzero",
    x: 8,
    y: 7,
    width: 1,
    height: 4,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    fillRule: "nonzero",
    x: 8,
    y: 12,
    width: 1,
    height: 1,
    rx: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkTriangle17);
export default __webpack_public_path__ + "static/media/exclamation-mark-triangle-17.fbd5fdcf.svg";
export { ForwardRef as ReactComponent };